var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRec1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 110,
    viewBox: "0 0 293 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.433 99.58C-18.6354 70.475 1.3876 -0.369405 56.1178 1.62722L255.573 8.90358C273.291 9.54993 288.371 22.712 291.313 40.0966C294.656 59.847 281.274 78.0401 261.424 80.7321L64.7351 107.407C52.2146 109.105 39.3521 106.332 28.433 99.58Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.35703
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRec1);
export default __webpack_public_path__ + "static/media/rec1.9ce52488b7fe97946a1f926a98606f45.svg";
export { ForwardRef as ReactComponent };